import PropTypes from 'prop-types';

import { Tooltip as MuiTooltip } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import Typography from 'components/UI/Typography/Typography';

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          padding: '10px',
          backgroundColor: '#FFFFFF',
          color: '#888B8D',
          boxShadow: '0px 8px 16px -2px #1B212C1F',
          borderRadius: '8px',
        },
        arrow: {
          color: '#FFFFFF',
        },
      },
    },
  },
});

const Tooltip = ({ children, title, typographyProps }) => (
  <ThemeProvider theme={theme}>
    <MuiTooltip
      title={
        <Typography type="text-sm" color="grey" {...typographyProps}>
          {title}
        </Typography>
      }
      placement="top"
      arrow
    >
      {children}
    </MuiTooltip>
  </ThemeProvider>
);

Tooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  typographyProps: PropTypes.object,
};

export default Tooltip;
